import { Button as MuiButton } from '@mui/material';

import type { ButtonProps } from '@mui/material';
import type { ButtonTypeMap } from '@mui/material/Button/Button';
import type { ExtendButtonBase } from '@mui/material/ButtonBase';

export const BUTTON_TEST_ID = 'button';

export const Button: ExtendButtonBase<ButtonTypeMap<ButtonProps>> = ({
  sx,
  ...props
}: ButtonProps) => (
  <MuiButton
    data-testid={BUTTON_TEST_ID}
    {...props}
    sx={{ textTransform: 'none', ...sx }}
  />
);
